// @ts-check

import { getCustomer } from '@/api/customers'
import {
  AUTHENTICATION_REQUIRED,
  IS_IN_MAIN_NAV,
  ROUTE_NAME
} from '@/router/meta'
import * as _ from 'lodash-es'

/** @type {import('vue-router').RouteRecordRaw[]} */
export const customerRoutes = [
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/views/Customers.vue'),
    meta: {
      [AUTHENTICATION_REQUIRED]: true,
      [IS_IN_MAIN_NAV]: true,
      icon: '$account-multiple-outline',
      [ROUTE_NAME]: 'customers'
    }
  },
  {
    path: '/customers/new',
    name: 'new_customer',
    component: () => import('@/views/EditCustomer.vue'),
    meta: {
      [AUTHENTICATION_REQUIRED]: true,
      [IS_IN_MAIN_NAV]: false,
      [ROUTE_NAME]: 'new_customer'
    }
  },
  {
    path: '/customers/:id',
    name: 'edit_customer',
    component: () => import('@/views/EditCustomer.vue'),
    beforeEnter: async (to) => {
      const { data: customer } = await getCustomer(to.params.id)

      if (!customer.can_edit) {
        return false
      }

      _.set(to, 'meta.customer', customer)

      return true
    },
    props: (route) => {
      return { customer: route.meta.customer }
    },
    meta: {
      [AUTHENTICATION_REQUIRED]: true,
      [IS_IN_MAIN_NAV]: false,
      [ROUTE_NAME]: 'edit_customer'
    }
  }
]

export default customerRoutes
